import * as React from 'react'
import {
  List,
  TextField,
  Datagrid,
  NumberField,
  TextInput,
  useGetIdentity,
  TopToolbar,
  FilterButton,
  ExportButton,
  DateField,
  FunctionField,
} from 'react-admin'
import { Chip } from '@material-ui/core'
import { useTranslate } from 'ra-core'
import { MyPagination } from '../../MyPagination'

const FilesFilters = [
  <TextInput key="campaign_id" source="campaign_id" />,
  <TextInput key="userId" source="userId" />,
]

const DeliveryListActions = () => (
  <TopToolbar>
    <FilterButton />
    <ExportButton />
  </TopToolbar>
)

const DeliveryList = props => {
  const translate = useTranslate()
  const { loading: identityLoading } = useGetIdentity()
  if (identityLoading) return <>Loading...</>
  return (
    <List
      {...props}
      actions={<DeliveryListActions />}
      bulkActionButtons={false}
      sort={{ field: 'id', order: 'DESC' }}
      filters={FilesFilters}
      pagination={<MyPagination />}
    >
      <Datagrid>
        <NumberField
          source="userId"
          label={translate('surveys.resources.user')}
        />
        <FunctionField
          label={translate('surveys.resources.campaign')}
          render={record => (
            <Chip
              size="small"
              label={`#${record.campaign_id}`}
              style={{ backgroundColor: '#e0f2fe', color: '#0369a1' }}
            />
          )}
        />
        <TextField source="url_envio" label="URL" />
        <TextField
          source="respuesta"
          label={translate('surveys.resources.response')}
        />
        <DateField
          source="createdAt"
          label={translate('surveys.common.registration_date')}
          emptyText="-"
          showTime
        />
      </Datagrid>
    </List>
  )
}

export default DeliveryList
